import { useState, useContext } from "react";
import { toast } from "react-toastify";
import henceforthApi from "../../utils/henceforthApi";
import { GlobalContext } from "../../context/Provider";


function ForgotPassword() {
  const { authDispatch } = useContext(GlobalContext); // If not used, you can remove this line

  const [state, setState] = useState({
    email: "",
    loading: false,
  });

  const onSubmitForm = (e) => {
    e.preventDefault();
    setState((prev) => ({ ...prev, loading: true }));

    henceforthApi.Auth.forgotPassword({ email: state.email })
      .then((res) => {
        toast.success(res.message);
        setState((prev) => ({ ...prev, loading: false }));
      })
      .catch((err) => {
        let error =
          err?.response?.body?.error_description || "Server error";
        toast.error(error);
        setState((prev) => ({ ...prev, loading: false }));
      });
  };

  return (
    <div className="passwordBox animated fadeInDown">
      <div className="row">
        <div className="col-md-12">
          <div className="ibox-content">
            <h2 className="font-bold text-center">Forgot password</h2>
            <p className="text-center" style={{ fontSize: "14px" }}>
              Enter your email address and your password will be reset and emailed to you.
            </p>

            <form className="m-t" onSubmit={onSubmitForm}>
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email address"
                  value={state.email}
                  onChange={(e) => setState({ ...state, email: e.target.value })}
                  required
                />
              </div>
              <button
                type="submit"
                className="btn btn-primary block full-width m-b"
                disabled={state.loading}
              >
                {state.loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>

          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
